module.exports = __webpack_public_path__ + "static/media/HalfSnappyLogo.747bba94.svg";